import { TextField } from "@mui/material";
import styled from "styled-components";

import arrow from "../../../../../assets/images/puchase-journey/select-arrow.svg";

export const inputColors = {
  linkColor: "#000000",
  contrastColor: "#CEDAF4",
  defaultColor: "#ffffff",
  borderColor: "#979797",
  iconColor: "#FD6520",
};

export const SelectComponent = styled(TextField)`
  && {
    width: 100%;
    background: ${inputColors.defaultColor};
    border-radius: 24px;
    margin-bottom: 5px;
  }

  && .MuiOutlinedInput-root {
    border-radius: 24px;
    background-color: ${inputColors.defaultColor};
  }

  && .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.borderColor};
  }

  && .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.iconColor};
  }

  && .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${inputColors.iconColor};
  }

  && .MuiNativeSelect-select {
    min-height: 24px;
    padding: 10px 42px 10px 16px;
    font-family: Figtree, sans-serif;
    font-size: 14px;
    color: ${inputColors.linkColor};
  }

  && .MuiNativeSelect-icon {
    width: 18px;
    height: 18px;
    right: 16px;
    color: transparent;
    background-image: url(${arrow});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  && .MuiSvgIcon-root {
    color: transparent;
    background-image: url(${arrow});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
`;

export const SelectLabel = styled.label`
  && {
    display: block;
    color: #ffffff;
    font-family: Figtree, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-left: 8px;
    margin-bottom: 10px;
  }
`;